<template>
  <div class="home">
    <component :is="componentName"></component>
  </div>
</template>

<script>
import WarrantySearch from "./routes/WarrantySearch";
import WarrantyActivation from "./routes/WarrantyActivation";
import WarrantyExtenish from "./routes/WarrantyExtenish";
export default {
  mounted() {},
  components: {
    WarrantySearch,
    WarrantyActivation,
    WarrantyExtenish
  },
  computed: {
    componentName() {
      return this.$route.name;
    },
  },
  data() {
    return {
      searchValue: "",
    };
  },
};
</script>

<style lang="stylus">
.home {
  width: 60%;
  float: right;
  min-height: 400px;
}

.isPhone .home {
  width: 100%;
  padding: 0;

  & > div {
    padding: 0 4%;

    .form-main {
      width: 100%;
      margin: 0 auto;
      padding-bottom: 30px;

      .product-input {
        text-align: right;

        .product-btn {
          margin-top: 16px;
        }
      }

      .product-btns .product-btn:last-child {
        margin-right: 0;
      }

      .el-textarea textarea, .product-list .el-input, .product-add .product-btn.add {
        width: 100%;
      }

      .product-list {
        margin-bottom: 48px;
      }

      .submit {
        padding-left: 0;
        text-align: center;

        .el-button {
          float: none;
          margin-top: 20px;
        }
      }

      .product-add {
        text-align: right;

        .add {
          margin-bottom: 20px;
        }

        .product-btn {
          width: 100%;
        }
      }
    }

    .form-title {
      span {
        font-size: 16px;
      }
    }

    .f12 {
      display: block;
      font-size: 14px;
      padding-left: 16px;
    }

    .table {
      width: 100%;
      margin: 0;

      .main-table {
        margin-bottom: 30px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/homePages/index.vue